package com.imobly.imobly.viewmodel

import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import androidx.navigation.NavHostController
import com.imobly.imobly.api.clearToken
import com.imobly.imobly.api.createHttpClient
import com.imobly.imobly.api.httpclient.GraphicHttpClient
import com.imobly.imobly.domain.graph.RentByMonth
import com.imobly.imobly.domain.graph.RentedProperties
import com.imobly.imobly.domain.graph.RentsPaidThisMonth
import kotlinx.coroutines.launch

class HomeViewModel(private val navController: NavHostController) : ViewModel() {
    val snackMessage: MutableState<SnackbarHostState> = mutableStateOf(SnackbarHostState())
    val showLogoutDialogState = mutableStateOf(false)

    fun changeShowLogoutDialog() {
        showLogoutDialogState.value = !showLogoutDialogState.value
    }

    fun goToGraphic() {
        navController.navigate("graphic")
    }

    fun goToShowProperties() {
        navController.navigate("showproperties")
    }

    fun goToShowCategories() {
        navController.navigate("showcategories")
    }

    fun goToShowTenants() {
        navController.navigate("showtenants")
    }

    fun goToShowReports() {
        navController.navigate("showreports")
    }

    fun goToShowAppointment() {
        navController.navigate("showappointments")
    }

    fun goToSendEmail() {
        navController.navigate("sendemail")
    }

    fun goToShowLeases() {
        navController.navigate("showleases")
    }

    fun goToEditLandLord() {
        navController.navigate("editlandlord")
    }

    fun goToLogin() {
        clearToken()
        navController.navigate("login")
    }

    fun logOut() {
        clearToken()
        goToLogin()
        viewModelScope.launch {
            snackMessage.value.showSnackbar("Sua conta foi deslogada sucesso!")
        }
    }
}